import { Map } from 'immutable';
import * as relocation from '../../actions/relocation/relocation';

const initialState = Map({
  clientServices: {},
  relocationPlanAlternateContact: {},
  caseTransfereeDetails: {},
  relocationPlanDependantDetails: {},
  relatedRoles: [],
});

const actionsMap = {
  [relocation.SAVE_CLIENT_SERVICES]: (state, action) => {
    return state.set('clientServices', action.data);
  },
  [relocation.SET_RELOCATION_PLAN_ALTERNATE_CONTACT]: (state, action) => {
    return state.set('relocationPlanAlternateContact', action.data);
  },
  [relocation.SET_CASE_TRANSFEREE_DETAILS]: (state, action) => {
    return state.set('caseTransfereeDetails', action.data);
  },
  [relocation.SET_RELOCATION_PLAN_DEPENDANT_DETAILS]: (state, action) => {
    return state.set('relocationPlanDependantDetails', action.data);
  },
  [relocation.SET_RELATED_ROLES]: (state, action) => {
    return state.set('relatedRoles', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}